export default __webpack_public_path__ + "static/media/Website images-01.dd44425a.jpg";